import { render, staticRenderFns } from "./StaffPopup.vue?vue&type=template&id=64669869&scoped=true&"
import script from "./StaffPopup.vue?vue&type=script&lang=js&"
export * from "./StaffPopup.vue?vue&type=script&lang=js&"
import style0 from "./StaffPopup.vue?vue&type=style&index=0&id=64669869&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64669869",
  null
  
)

export default component.exports